
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-button.js';
import './collapse-transition-mixin.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import './pendo-divider.js';
import 'element-ui/lib/checkbox';
import './pendo-checkbox.js';
import 'lodash/uniqueId';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/isPlainObject';
import 'lodash/debounce';
import './pendo-empty-state.js';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import PendoIconButton from './pendo-icon-button.js';
import './pendo-responsive.js';
import 'lodash/cloneDeep';
import 'lodash/keyBy';
import 'scrollparent';
import 'vue-observe-visibility';
import PendoTable from './pendo-table.js';
import './pendo-checkbox-cell.js';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import './pendo-column-reorder.js';
import './pendo-column-chooser.js';
import 'lodash/groupBy';
import './pendo-icon-option.js';
import 'lodash/startCase';
import './pendo-guide-status-option.js';
import 'lodash/some';
import PendoResourceColumnChooser from './pendo-resource-column-chooser.js';
import './pendo-group-option.js';
import PendoStatusOverlay from './pendo-status-overlay.js';
import PendoChartTrigger from './pendo-chart-trigger.js';
import PendoGuideProgressCell from './pendo-guide-progress-cell.js';

var script = {
  name: 'PendoGuideActivityTable',
  components: {
    PendoChartTrigger,
    PendoGuideProgressCell,
    PendoIconButton,
    PendoMultiselect,
    PendoTable,
    PendoStatusOverlay,
    PendoResourceColumnChooser
  },
  props: {
    sortConfig: {
      type: Object,
      default: () => ({
        prop: 'visitorId',
        order: 'none'
      })
    },
    columns: {
      type: Array,
      required: true
    },
    activityData: {
      type: Array,
      required: true
    },
    guideActivityAggStatus: {
      type: String,
      required: true
    },
    loadingOptions: {
      type: Object,
      default: () => {}
    },
    selectedActivityType: {
      type: Object,
      default: () => ({
        id: 'byVisitor',
        label: 'By Visitor'
      })
    },
    selectedActivityFilter: {
      type: Object,
      default: () => ({
        id: 'everyone',
        label: 'Everyone'
      })
    },
    showActivityFilter: {
      type: Boolean,
      default: false
    },
    featuresList: {
      type: Array,
      default: () => []
    },
    guidesList: {
      type: Array,
      default: () => []
    },
    pagesList: {
      type: Array,
      default: () => []
    },
    savingColumnChooser: {
      type: Boolean,
      default: false
    },
    isLoadingResources: {
      type: Boolean,
      default: false
    },
    isLoadingMetadata: {
      type: Boolean,
      default: false
    },
    metadataList: {
      type: Array,
      default: () => []
    },
    showCsvDownloadButton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showCsvDownloadModal: false,
      showManageColumnsModal: false,
      activityTypeOptions: [{
        id: 'byVisitor',
        label: 'By Visitor'
      }, {
        id: 'byEvent',
        label: 'All Events'
      }],
      activityFilterOptions: [{
        id: 'everyone',
        label: 'Everyone'
      }, {
        id: 'seen',
        label: 'Has Seen Guide'
      }, {
        id: 'notSeen',
        label: 'Has Not Seen Guide'
      }]
    };
  },

  watch: {
    savingColumnChooser(newVal, oldVal) {
      if (!newVal && oldVal && this.showManageColumnsModal) {
        this.showManageColumnsModal = false;
      }
    }

  },
  methods: {
    onSortChange({
      prop,
      order
    }) {
      this.$emit('sortChange', {
        prop,
        order
      });
    },

    onActivityTypeSelect(type) {
      this.$emit('activityTypeSelect', type);
    },

    onActivityFilterSelect(filter) {
      this.$emit('activityFilterSelect', filter);
    },

    downloadCsv() {
      this.$emit('downloadCsv');
    },

    manageColumns() {
      this.$emit('manageColumns');
      this.showManageColumnsModal = true;
    },

    fetchResources(id) {
      this.$emit('fetchResources', id);
    },

    onConfirmColumnsChange(formattedColumnsForTable) {
      this.$emit('confirmColumnsChange', formattedColumnsForTable);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-guide-activity-table"
  }, [_c('pendo-table', {
    ref: "guideActivityTable",
    attrs: {
      "title": "Guide Activity",
      "data": _vm.activityData,
      "columns": _vm.columns,
      "csv-download": _vm.showCsvDownloadButton && _vm.downloadCsv,
      "default-sort": _vm.sortConfig,
      "scroll-config": {
        rowHeight: null
      },
      "tree-config": {
        children: 's'
      },
      "height": 600
    },
    on: {
      "sort-change": _vm.onSortChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function () {
        return [_c('pendo-status-overlay', {
          attrs: {
            "state": _vm.guideActivityAggStatus,
            "options": _vm.loadingOptions
          }
        })];
      },
      proxy: true
    }, {
      key: "headerLeft",
      fn: function () {
        return [_c('div', {
          staticClass: "pendo-guide-activity-table__header"
        }, [_c('div', {
          staticClass: "pendo-guide-activity-table__title"
        }, [_vm._v("\n                    Guide Activity\n                ")]), _vm._v(" "), _c('pendo-multiselect', {
          staticClass: "pendo-guide-activity-table__type-filter",
          attrs: {
            "value": _vm.selectedActivityType,
            "options": _vm.activityTypeOptions,
            "max-menu-width": 120,
            "append-to-body": false
          },
          on: {
            "select": _vm.onActivityTypeSelect
          }
        }, [_c('pendo-chart-trigger', {
          attrs: {
            "slot": "trigger"
          },
          slot: "trigger"
        })], 1), _vm._v(" "), _vm.showActivityFilter ? _c('pendo-multiselect', {
          staticClass: "pendo-guide-activity-table__type-filter",
          attrs: {
            "value": _vm.selectedActivityFilter,
            "allow-empty": false,
            "options": _vm.activityFilterOptions,
            "max-menu-width": 170,
            "append-to-body": false
          },
          on: {
            "select": _vm.onActivityFilterSelect
          }
        }, [_c('pendo-chart-trigger', {
          attrs: {
            "slot": "trigger"
          },
          slot: "trigger"
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "headerActions",
      fn: function () {
        return [_c('pendo-icon-button', {
          staticClass: "pendo-table__title-action pendo-table__title-action--columns",
          attrs: {
            "tooltip": "Manage Columns",
            "icon": "columns",
            "icon-size": "16"
          },
          on: {
            "click": _vm.manageColumns
          }
        })];
      },
      proxy: true
    }, {
      key: "stepsSeen",
      fn: function (ref) {
        var row = ref.row;
        return [!row.stepIndex ? _c('pendo-guide-progress-cell', {
          attrs: {
            "row": row
          }
        }) : _vm._e(), _vm._v(" "), row.stepIndex ? [_vm._v("\n                Step " + _vm._s(row.stepIndex) + "\n            ")] : _vm._e()];
      }
    }])
  }), _vm._v(" "), _c('pendo-resource-column-chooser', {
    attrs: {
      "visible": _vm.showManageColumnsModal,
      "columns": _vm.columns,
      "saving": _vm.savingColumnChooser,
      "features-list": _vm.featuresList,
      "guides-list": _vm.guidesList,
      "pages-list": _vm.pagesList,
      "is-loading-resources": _vm.isLoadingResources,
      "is-loading-metadata": _vm.isLoadingMetadata,
      "metadata-list": _vm.metadataList
    },
    on: {
      "fetch-resources": _vm.fetchResources,
      "cancel": function ($event) {
        _vm.showManageColumnsModal = false;
      },
      "close": function ($event) {
        _vm.showManageColumnsModal = false;
      },
      "confirm": _vm.onConfirmColumnsChange
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-guide-activity-table.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoGuideActivityTable = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoGuideActivityTable;
